import { useState } from 'react';
import AssistantChatPanel from './AssistantChatPanel';

export default function AssistantWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Botón flotante */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-teal-600 text-white rounded-full shadow-lg hover:bg-teal-700 transition-all hover:scale-110 z-50 flex items-center justify-center"
        aria-label="Abrir asistente de cotización"
      >
        {isOpen ? (
          <i className="ri-close-line text-2xl"></i>
        ) : (
          <i className="ri-message-3-line text-2xl"></i>
        )}
      </button>

      {/* Panel de chat */}
      <AssistantChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
